exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".bg-docs-home{background:linear-gradient(180deg,#00adef 80%,#2bd9ef)}.call-header{color:#fff;text-align:center}.img-responsive-center{margin:0 auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-16d1e619","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./docs/pages/home.vue
// module id = 418
// module chunks = 0